import cx from "classnames";
import React from "react";

import { CheckInCircle, CheckInCircleSolid, RadioBtnOff } from "@gaming/xds-react-js-icons";

import { useStrings } from "../../localization/localizationHelpers";
import * as styles from "./FormSectionHeader.module.css";

export type FormSectionStatus = "notStarted" | "inProgress" | "complete";

export const getFormSectionStatus = (isStarted: boolean, isValid: boolean): FormSectionStatus =>
  !isStarted ? "notStarted" : isValid ? "complete" : "inProgress";

type FormSectionHeaderProps = Readonly<{
  status: FormSectionStatus;
  title: string;
  subtitle?: string;
}>;

export const FormSectionHeader = ({ status, title, subtitle }: FormSectionHeaderProps) => {
  const [notStartedLabel, inProgressLabel, completeLabel] = useStrings(
    "notStarted",
    "inProgress",
    "complete"
  );

  const statusLabel =
    status === "complete"
      ? completeLabel
      : status === "inProgress"
      ? inProgressLabel
      : notStartedLabel;

  const renderIcon = () => {
    if (status === "complete") {
      return <CheckInCircleSolid className={cx(styles.statusIcon, styles.statusIconComplete)} />;
    }
    if (status === "inProgress") {
      return <CheckInCircle className={cx(styles.statusIcon, styles.statusIconInProgress)} />;
    }
    return <RadioBtnOff className={cx(styles.statusIcon, styles.statusIconNotStarted)} />;
  };

  return (
    <span className={styles.header}>
      {renderIcon()}
      <span className={styles.titleBlock}>
        <span className={styles.title}>{title}</span>
        <span className={styles.statusRow}>
          <span
            className={cx(styles.statusLabel, {
              [styles.statusLabelComplete]: status === "complete",
            })}
          >
            {statusLabel}
          </span>
          {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        </span>
      </span>
    </span>
  );
};
